"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emoji_1 = require("./emoji");
const hard_break_1 = require("./hard-break");
const index_1 = require("./index");
const mention_1 = require("./mention");
const text_1 = require("./text");
class Paragraph extends index_1.TopLevelNode {
    constructor() {
        super(...arguments);
        this.content = new index_1.ContentNode('paragraph');
    }
    text(text, marks) {
        return this.add(new text_1.Text(text, marks));
    }
    code(text) {
        return this.add(text_1.code(text));
    }
    em(text) {
        return this.add(text_1.em(text));
    }
    link(text, href, title) {
        return this.add(text_1.link(text, href, title));
    }
    strong(text) {
        return this.add(text_1.strong(text));
    }
    mention(id, text) {
        return this.add(new mention_1.Mention(id, text));
    }
    emoji(shortName, id, text) {
        return this.add(new emoji_1.Emoji({ shortName, id, text }));
    }
    hardBreak() {
        return this.add(new hard_break_1.HardBreak());
    }
    add(node) {
        this.content.add(node);
        return this;
    }
    toJSON() {
        return this.content.toJSON();
    }
}
exports.Paragraph = Paragraph;
//# sourceMappingURL=paragraph.js.map